class I18N {

  #translations = {};

  /**
   * Adds translations to global translation object.
   *
   * @param {object} translations Translations key and value.
   */
  addTranslations(translations) {
    if (typeof translations !== 'object') {
      throw new Error('Object containing localisation key and value expected.');
    }

    this.#translations = {
      ...this.#translations,
      ...translations,
    };
  }

  /**
   * Get translated string.
   *
   * @param {string} key Translation key.
   * @param {object} params Replacement values.
   * @return {string} Localized string
   */
  translate(key, params = {}) {
    const value = this.#translations[key];
    if (typeof value === 'string') {
      return replacePlaceholders(value, params);
    }
    return key;
  }

}

const i18n = new I18N();
export default i18n;


/**
 * Get translated string.
 *
 * @param {string} key Translation key.
 * @param {object} params Replacement values.
 * @return {string} Localized string
 */
function t(key, params) {
  return i18n.translate(key, params);
}

/**
 * Replaces placeholders with provided values.
 *
 * @param {string} string Value with placeholders.
 * @param {object} params Replacement values.
 * @return {string} String with replaced placeholders.
 */
function replacePlaceholders(string, params) {
  if (typeof params === 'object') {
    for (let param in params) {
      string = string.split('%' + param + '%').join(params[param]);
    }
  }
  return string;
}

export { t, replacePlaceholders };
